import { Tooltip, withStyles } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { sujeitoAtencaoOrcamentoHeader } from "../../../services/OrcamentoService";
import moment from "moment";
import { Button } from "../../../components/ui/Buttons";
import OrcamentoEmitidoIcon from "../../../components/Icon/OrcamentoEmitidoIcon";
import { withRouter } from "react-router-dom";
import { TextFieldSearch } from "../../../components/TextField";
import { inject } from "mobx-react";
import { observer } from "mobx-react-lite";
import { findAllStatusOrcamentoOdontologicoSelect } from "../../../services/StatusOrcamentoService";
import { findAllProfissionalSaude } from "../../../services/ProfissionalSaudeService";
import { runInAction } from "mobx";

const dadosSujeitoAtencaoDefault = {
  nome: "",
  contato: {
    telefonePrincipal: "",
    email: "",
  },
};
const Header = observer(
  ({ classes, sujeitoAtencao, orcamento, history, orcamentoStore, sujeitoAtencaoStore }) => {
    const [dadosSujeitoAtencao, setDadosSujeitoAtencao] = useState(
      dadosSujeitoAtencaoDefault
    );
    const [loadingIrOrcamentos, setLoadingIrOrcamentos] = useState(false);

    const { nome, contato } = dadosSujeitoAtencao || {};
    const {
      statusOrcamentoOdontologico,
      dataHoraLancamento,
      id: orcamentoId,
      numero,
    } = orcamento || {};
    const { id } = sujeitoAtencao || {};

    useEffect(() => {
      sujeitoAtencao?.id && getDadosSujeitoAtencao();
    }, [sujeitoAtencao]);

    const getDadosSujeitoAtencao = async () => {
      try {
        const response = await sujeitoAtencaoOrcamentoHeader(id);
        setDadosSujeitoAtencao(response);
      } catch (error) {
        console.error(error);
      }
    };

    const loadProfissionaisSaude = async (search, loadedOptions, { page }) => {
      try {
        const { content, last } = (
          await findAllProfissionalSaude({
            pageNumber: page,
            search,
          })
        ).data.data.findAllProfissionalSaude
        return {
          options: content,
          hasMore: !last,
          additional: {
            page: page + 1,
          },
        }
      } catch (error) {
        console.error(error)
      }
    }

    const loadStatusOrcamento = async (search, loadedOptions, { page }) => {
      const pageableDTO = {
        pageNumber: page,
        pageSize: 10,
        sortDir: "ASC",
        sortField: "nome",
      };
      const variables = {
        pageableDTO,
        search,
        ativo: true,
      };

      try {
        const {
          content,
          last,
        } = await findAllStatusOrcamentoOdontologicoSelect(variables);
        return {
          options: content,
          hasMore: !last,
          additional: {
            page: page + 1,
          },
        };
      } catch (error) {
        console.error(error);
      }
    };

    const handleStatus = (status) => {
      orcamentoStore.handleFieldModal("statusOrcamentoOdontologico", status);
    };

    const handleIrOrcamentos = async() => {
      try {
        setLoadingIrOrcamentos(true);
        runInAction(() => {
          sujeitoAtencaoStore.load(id);
        });
        history.push(`/sujeito-atencao/edit/${id}/orcamentos`);
      } catch (error) {
        console.error(error);
      } finally {
        setLoadingIrOrcamentos(false);
      }
    };

    return (
      <div className={classes.container}>
        <div className={classes.orcamentoNome}>
          <div className={classes.nomeSujeito}>
            <h2>{nome}</h2>
            <Tooltip title="Ir para orçamentos">
              <Button
                shape="circle"
                bgColor="#219A97"
                onClick={handleIrOrcamentos}
                padding={0}
                style={{ height: 24, width: 24, display: "flex" }}
                isLoading={loadingIrOrcamentos}
                disabled={loadingIrOrcamentos}
              >
                <OrcamentoEmitidoIcon size='14' />
              </Button>
            </Tooltip>
          </div>
          {orcamentoId && (
            <div className={classes.field}>
              <p className={classes.nameField}>Nº:</p>
              <p>{numero}</p>
            </div>
          )}
        </div>
        <div className={classes.rowDadosContato}>
          <div className={classes.field}>
            <p className={classes.nameField}>Telefone:</p>
            <p>{contato?.telefonePrincipal || orcamento?.sujeitoAtencao?.contato?.telefonePrincipal}</p>
          </div>
          <div className={classes.row}>
            <div className={classes.field}>
              <p className={classes.nameField}>E-mail:</p>
              <p>{contato?.email || orcamento?.sujeitoAtencao?.contato?.email}</p>
            </div>
            {orcamentoId && (
            <div className={classes.field}>
              <p className={classes.nameField}>Lançamento:</p>
              <p>{moment(dataHoraLancamento).format("DD/MM/YYYY HH:mm")}</p>
            </div>
          )}
          </div>
        </div>
        <div className={classes.rowStatus}>
            <div className={classes.fieldStatus}>
              <div className={classes.contentSelectStatus}>
                <span className={classes.titleInput}>Status:</span>
                <TextFieldSearch
                  placeholder="Status"
                  classIcons={classes.classIcons}
                  classInput={classes.reactSelect}
                  classNotched={classes.notchedOutline}
                  loadOptions={loadStatusOrcamento}
                  getOptionLabel={(option) => option?.nome}
                  getOptionValue={(option) => option?.id}
                  value={statusOrcamentoOdontologico}
                  classes={{ paper: classes.menuHeight }}
                  onChange={handleStatus}
                  withPaginate
                  debounceTimeout={300}
                  additional={{
                    page: 0,
                  }}
                  menuPosition="fixed"
                />
              </div>

              <div className={classes.contentSelectOrcamentista}>
                <span className={classes.titleInput}>Orçamentista:</span>
                <TextFieldSearch
                  placeholder='Selecione'
                  classIcons={classes.classIcons}
                  classInput={classes.reactSelect}
                  classNotched={classes.notchedOutline}
                  loadOptions={loadProfissionaisSaude}
                  getOptionLabel={option => option?.nome}
                  getOptionValue={option => option?.id}
                  value={orcamentoStore.orcamento.orcamentista}
                  classes={{ paper: classes.menuHeight }}
                  onChange={e => orcamentoStore.handleFieldModal('orcamentista', e)}
                  withPaginate
                  debounceTimeout={300}
                  additional={{
                    page: 0,
                  }}
                  menuPosition='fixed'
                  isClearable={false}
                />
              </div>

              <div className={classes.contentSelectOrcamentista}>
                <span className={classes.titleInput}>Profissional Executante:</span>
                <TextFieldSearch
                  placeholder='Selecione'
                  classIcons={classes.classIcons}
                  classInput={classes.reactSelect}
                  classNotched={classes.notchedOutline}
                  loadOptions={loadProfissionaisSaude}
                  getOptionLabel={option => option?.nome}
                  getOptionValue={option => option?.id}
                  value={orcamentoStore.orcamento.profissionalExecutante}
                  classes={{ paper: classes.menuHeight }}
                  onChange={e => orcamentoStore.handleFieldModal('profissionalExecutante', e)}
                  withPaginate
                  debounceTimeout={300}
                  additional={{
                    page: 0,
                  }}
                  menuPosition='fixed'
                />
              </div>
            </div>
        </div>
      </div>
    );
  }
);

const style = {
  container: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
  },
  orcamentoNome: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    "& h2": {
      margin: 0,
    },
  },
  rowDadosContato: {
    display: "flex",
    flexDirection: "column",
  },
  row: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },
  rowStatus: {
    display: "flex",
  },
  field: {
    display: "flex",
    gap: "4px",
    alignItems: "center",
    "& > p": {
      margin: 0,
    },
    textWrap: 'nowrap',
  },
  fieldStatus: {
    display: 'flex',
    gap: '10px',
    width:'100%',
  },
  nameField: {
    fontSize: "12px",
    color: "#505050",
  },
  nomeSujeito: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "8px",
  },
  contentSelectOrcamentista:{
    flex: 1,
    maxWidth: "50%",
  },
  contentSelectStatus: {
    flex: 1,
  },
};

const HeaderWithStylesRouter = withRouter(
  withStyles(style)(Header)
);
export default inject("orcamentoStore", "sujeitoAtencaoStore")(HeaderWithStylesRouter);
